import cn from 'classnames/bind';
import { Container, Row, Col, Text } from 'ui';
import AboutUsCard from 'ui/components/home/AboutUsCard';
import WithTornBackground from 'ui/layouts/WithTornBackground';

import s from './AboutUsSection.module.scss';

const cx = cn.bind(s);

const AboutUsSection = ({
  children, className, cards = [], text, title = 'Insightful personality test designed by experts', ...attrs
}) => (
  <section className={cx(className, 'section')} {...attrs}>
    <WithTornBackground skipContentOffset>
      <Container className={cx('container')}>
        <Row className={cx('infoBlock')}>
          <Col md={{ offset: 1, span: 10 }} xl={{ offset: 2, span: 8 }}>
            <h2
              className={cx(
                'title',
                'tp-mobile-header-2 md:tp-tablet-header-2 xl:tp-subheader-2',
              )}
            >
              {title}
            </h2>
            <Text className={cx('info', 'xl:p-0 xl:!text-[20px] lg:px-[10px] md:text-[18px]')}>
              {text}
            </Text>
          </Col>
        </Row>
        <Row>
          <Col
            xl={{offset: 1, span: 10}}
            lg={{ offset: 0, span: 12 }}
            md={{ offset: 1, span: 10 }}
            xs={12}
            className={cx('cardsColumn')}
          >
            <div className={cx('cards')}>
              {cards.map((card) => (
                <AboutUsCard
                  key={card.title}
                  color={card.color}
                  className={cx('card')}
                  title={card.title}
                  text={card.text}
                  linkText={card.linkText}
                  linkUrl={card.linkUrl}
                />
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </WithTornBackground>
  </section>
);

export default AboutUsSection;
